import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://uuoyrzwnvxuxboapprzb.supabase.co'
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV1b3lyendudnh1eGJvYXBwcnpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzQ0MzcyMjIsImV4cCI6MTk5MDAxMzIyMn0.lnmxVLEfstB2KMIKwl9q33D3TiAr41HEdPMgnlM2EG8";

const conn = createClient(supabaseUrl, supabaseKey)

export const auth = conn.auth;

export default conn;